<template>
  <div>
    <label class="text-xs font-medium text-gray-600" v-if="label">
      {{ label }}
      <span v-if="required" class="text-red-700">*</span>
    </label>

    <v-textarea v-model="internalValue" :placeholder="placeholder" :variant="variant" :density="density"
      :auto-grow="autoGrow" :hide-details="hideDetails" :color="color" :rows="rows" :rules="rules" :disabled="disabled"
      :maxlength="maxlength" :counter="counter" />
  </div>
</template>

<script>
export default {
  name: "FormTextarea",
  props: {
    label: { type: String },
    placeholder: { type: String, default: "" },
    modelValue: { type: String, default: "" },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tooltip: { type: String, default: null },
    rows: { type: Number, default: 2 },
    autoGrow: { type: Boolean, default: true },
    variant: { type: String, default: "outlined" },
    density: { type: String, default: "compact" },
    hideDetails: { type: String, default: "auto" },
    color: { type: String, default: "#475569" },
    rules: { type: Array, default: () => [] },
    maxlength: { type: [String, Number], default: undefined },
    counter: { type: [Boolean, String, Number], default: undefined },
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
